import { useQuery } from 'react-query';

import processResponseError from '@System/api/processResponseError';

import api from '../services/api';

const useListDropshipQuery = params => {
    return useQuery(['ListDropshippingQuery', params], () => api.getProductDropshipping(params), {
        retry: false,
        onError: err => {
            processResponseError(err);
        },
    });
};

export default useListDropshipQuery;
